<template>
  <div class="ride-blank-map">
    <div class="map-wrapper" id="ride-blank-map">
      <div :id="mapID" class="map">
        <div class="leaflet-top leaflet-right">
          <div class="center-btn button is-white is-rounded" @click="recenter">
            <i class="fa fa-crosshairs" :class="{ 'fa-spin': spin }" />
          </div>
        </div>
      </div>
    </div>

    <div class="warning">
      <span v-show="warning" class="tag is-danger">
        <i class="fa fa-exclamation-triangle" />
        <span v-html="warning" style="margin-left: 6px" />
      </span>
    </div>
  </div>
</template>

<script>
import geo from "@/geo";
import L from "leaflet";
import "leaflet.awesome-markers";

export default {
  name: "RideBlankMap",
  props: { workflow: Object },
  data() {
    return {
      mapID: "ride-blank-map-map",
      map: null,
      warning: null,
      userMarker: null,
      spin: false,
    };
  },
  computed: {},
  mounted() {
    this.initMap();
    this.watchUserLocation();
    this.checkWarning();
  },
  activated() {
    this.updateUserMarker();
  },
  methods: {
    checkWarning() {
      // check time of last user location, if old prompt update
      var userState = this.$store.state.userState;
      if (!userState) {
        this.warning = this.$t("ride.please-grant-gps-permission");
        return;
      }
      var updatedAt = new Date(userState.updated_at);
      var minutes = (new Date().getTime() - updatedAt.getTime()) / (1000 * 60);
      if (minutes > 10) this.warning = this.$t("ride.your-gps-is-old");
      else this.warning = null; // GPS is update-to-date
    },
    watchUserLocation() {
      this.$store.subscribe((mutation) => {
        if (mutation.type === "setUserState") {
          this.warning = null;
          var coords = this.$store.getters.getUserLatLon;
          this.userMarker.setLatLng(coords);
        }
      });
    },
    recenter() {
      this.spin = true;
      setTimeout(() => (this.spin = false), 600);
      this.updateUserMarker(true);
    },
    initMap() {
      var tilesURL = this.$t("geo.map-tiles"); // language specific maps

      this.map = L.map(this.mapID, { attributionControl: false });
      var coords = this.$store.getters.getUserLatLonWithFallback;
      this.map.setView(coords, 16);

      L.tileLayer(tilesURL, {
        tileSize: 512,
        zoomOffset: -1,
        // minZoom: 12,
        maxZoom: 19,
        attribution: `&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>`,
      }).addTo(this.map);

      L.control.attribution({ position: "topright" }).addTo(this.map);

      this.map.zoomControl.remove();
      this.drawUserLocation();
    },
    drawUserLocation() {
      var coords = this.$store.getters.getUserLatLon;
      var icon = L.divIcon({
        html: `<div class="blue-dot pulse"></div>`,
        popupAnchor: [7, -6],
        className: "none",
      });
      this.userMarker = L.marker(coords, { icon: icon });
      this.userMarker.addTo(this.map);
      var popupOpts = { closeButton: false, autoPan: true };
      this.userMarker.bindPopup(this.$t("ride.your-current-gps"), popupOpts);
    },
    updateUserMarker(flyTo) {
      var coords = this.$store.getters.getUserLatLon;
      if (!coords) return;
      this.userMarker.setLatLng(coords);
      if (flyTo) this.map.flyTo(coords);
      else this.map.setView(coords, 17);
    },

    farAwayFromUser(p, dist) {
      if (this.$store.getters.isSuperUser) return false; // show all drivers to superuser
      if (this.isDispatcher) return false; // show all drivers to dispatcher
      var coords = this.$store.getters.getUserLocation;
      if (!coords) return false;
      var userLoc = { lat: coords[0], lon: coords[1] };
      if (geo.distanceToUserInMeters(p, userLoc) > dist) return true;
      return false;
    },
  },
};
</script>

<style scoped>
.map-wrapper {
  position: absolute;
  top: 0;
  height: calc(100vh - 195px);
  width: 100vw;
  z-index: 0;
}
.map {
  position: relative;
  height: 100%;
  width: 100%;
}
.warning {
  font-weight: 450;
  position: absolute;
  top: 12px;
  width: 100vw;
  text-align: center;
  /* font-size: 0.8em; */
}
.center-btn {
  margin: 10px;
  padding: 0 9px;
  pointer-events: auto;
  /* color: rgb(0, 106, 255); */
  color: grey;
  box-shadow: 0 0 4px grey;
}
</style>

<style lang="scss">
#ride-blank-map-map {
  .leaflet-popup-content {
    padding: 5px 5px;
    margin: 1px 0;
    // color: rgb(23, 23, 193);
    color: rgb(23, 102, 193);
    font-size: 1.2em;
    // max-width: 130px;
  }
  .leaflet-popup-content i {
    font-weight: 500;
    opacity: 0.8;
    color: grey;
  }
  .blue-dot {
    margin-left: 6px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    background-color: #2693da;
    opacity: 0.9;
    border: 1px solid #feeaa4b5;
  }
  .pulse {
    animation: pulsate-1 3s ease-out infinite;
  }
  //   @keyframes shadow-pulse1 {
  //     0% {
  //       box-shadow: 0 0 2px 1px yellow;
  //     }
  //     100% {
  //       box-shadow: 0 0 4px 4px pink;
  //       //   box-shadow: 0 0 0 4px #2692da55;
  //     }
  //   }
  @keyframes pulsate-1 {
    0% {
      box-shadow: 0 0 0 1px cyan;
    }
    50% {
      box-shadow: 0 0 0 6px rgba(255, 217, 0, 0.5);
    }
    100% {
      box-shadow: 0 0 0 1px lightskyblue;
    }
  }
  // @-webkit-keyframes pulsate-1 {
  //   0% {
  //     box-shadow: 0 0 0 1px cyan;
  //   }
  //   50% {
  //     box-shadow: 0 0 0 6px rgba(255, 217, 0, 0.5);
  //   }
  //   100% {
  //     box-shadow: 0 0 0 1px lightskyblue;
  //   }
  // }
}
</style>